'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// LIBS


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _core = require('@material-ui/core');

var _utils = require('@material-ui/core/utils');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = exports.styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var borderColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  var buttonSelectedColor = theme.palette.primary.contrastText;

  return {
    root: {
      position: 'relative',
      display: 'flex',
      border: '1px solid',
      borderColor: borderColor,
      borderRadius: 999
    },
    selector: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: 999,
      transition: 'all ease-in .2s',
      zIndex: 1
    },
    selectorPrimary: {
      background: theme.palette.primary.main
    },
    selectorSecondary: {
      background: theme.palette.secondary.main
    },
    buttonContainer: {
      flex: 1
    },
    buttonRoot: {
      borderRadius: 999,
      padding: '10px 20px',
      zIndex: 2
    },
    buttonLabel: {},
    buttonSelected: {
      color: buttonSelectedColor
    }
  };
};

function SegmentedControl(_ref) {
  var buttonProps = _ref.buttonProps,
      classes = _ref.classes,
      color = _ref.color,
      onChange = _ref.onChange,
      options = _ref.options,
      value = _ref.value;

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectorStyle = _useState2[0],
      setSelectorStyle = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      windowWidth = _useState4[0],
      setWindowWidth = _useState4[1];

  var buttonRefs = [];
  options.map(function () {
    return buttonRefs.push(_react2.default.createRef());
  });

  (0, _react.useEffect)(function () {
    var index = options.findIndex(function (option) {
      return option.value === value;
    });
    if (index !== -1) {
      var button = buttonRefs[index].current;
      var width = Math.round(button.getBoundingClientRect().width) + 1;
      var left = Math.round(button.getBoundingClientRect().x - button.parentNode.getBoundingClientRect().x) - 1;
      setSelectorStyle({
        width: width,
        left: left
      });
    }
  }, [value, windowWidth]);

  (0, _react.useEffect)(function () {
    var handleResize = function handleResize() {
      return setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  });

  var selectorColorClass = 'selector' + (0, _utils.capitalize)(color);

  return _react2.default.createElement(
    'div',
    { className: classes.root },
    options.map(function (opt, index) {
      return _react2.default.createElement(
        _core.Button,
        _extends({
          key: opt.value,
          ref: buttonRefs[index],
          className: (0, _classnames2.default)(_defineProperty({}, classes.buttonSelected, opt.value === value)),
          classes: {
            root: classes.buttonRoot,
            label: classes.buttonLabel
          },
          fullWidth: true,
          onClick: function onClick() {
            return onChange(opt.value);
          }
        }, buttonProps),
        opt.label
      );
    }),
    value && _react2.default.createElement('div', {
      className: (0, _classnames2.default)(classes.selector, classes[selectorColorClass]),
      style: selectorStyle
    })
  );
}

SegmentedControl.propTypes = {
  buttonProps: (0, _propTypes.shape)({}),
  classes: (0, _propTypes.shape)({}),
  color: (0, _propTypes.oneOf)(['primary', 'secondary']),
  onChange: _propTypes.func,
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string,
    value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  })).isRequired,
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
};

SegmentedControl.defaultProps = {
  buttonProps: {},
  classes: {},
  color: 'primary',
  onChange: function onChange() {
    return null;
  },
  value: null
};

exports.default = (0, _core.withStyles)(styles)(SegmentedControl);